import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/(public)/consultation/page.tsx");
